module.exports = __webpack_public_path__ + "store/img/tag_size_large.642fbd0b.svg";